<template>
  <v-data-table
    :titulo="titulo"
    :headers="headers"
    :items="tags"
    sort-by="descricao"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>{{ titulo }}</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-btn
          text
          icon
          :loading="loading"
          class="mr-3"
          @click="initialize"
        >
          <v-icon>fa-redo-alt</v-icon>
        </v-btn>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" small fab dark class="mb-2" v-on="on">
              <v-icon small>fa-plus</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="editedItem.descricao" label="Descrição"></v-text-field>
                    <v-select
                      v-model="editedItem.cor"
                      label="Cor"
                      :items="colorsPicker"
                    >
                    <template v-slot:selection="{ item }">
                        <div class="d-flex align-center">
                          <v-list-item class="pl-0">
                            <v-chip small :color="item.value"></v-chip>
                            <span class="pl-3">{{ item.text }}</span>
                          </v-list-item>
                        </div>
                      </template>
                      <template v-slot:item="{ item }">
                        <v-chip small :color="item.value"></v-chip>
                        <v-list-item>{{ item.text }}</v-list-item>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        fa-edit
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        fa-trash
      </v-icon>
    </template>
    <template v-slot:item.cor="{ item }">
      <div>
        <v-chip small :color="item.cor"></v-chip>
      </div>
    </template>
    <template v-slot:no-data>
      <span class="pr-3">Nenhum registro encontrado</span>
      <v-btn
        text
        icon
        :loading="loading"
        class="mr-3"
        @click="initialize"
      >
        <v-icon>fa-redo-alt</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import colors from 'vuetify/lib/util/colors';
import Tag from '../../domain/tag/Tag';
import { mapGetters, mapActions, mapMutations } from 'vuex';

  export default {
    name: 'TagsLista',
    props: {
      titulo: String
    },
    data: () => ({
      dialog: false,
      headers: [
        {
          text: 'Descrição',
          align: 'start',
          value: 'descricao',
        },
        { text: 'Cor', value: 'cor', sortable: false },
        { text: 'Ações', value: 'actions', sortable: false },
      ],
      editedIndex: -1,
      editedItem: new Tag(),
      defaultItem: new Tag(),
    }),

    computed: {
      ...mapGetters(['tags', 'loading']),
      formTitle () {
        return this.editedIndex === -1 ? 'Nova Tag' : 'Edita Tag'
      },
      colorsPicker() {
        const colorsArray = []

        for (const key of Object.keys(colors)) {
          if (!!colors[key] && !!colors[key].base) {
            colorsArray.push({ text: key, value: colors[key].base });
          }
        }

        return colorsArray;
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      ...mapActions([
        'fetchTags',
        'createTag',
        'updateTag',
        'deleteTag',
      ]),
      ...mapMutations(['showSnackbar']),
      initialize () {
        this.fetchTags({});
      },

      editItem (item) {
        this.editedIndex = this.tags.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },

      deleteItem (item) {
        const index = this.tags.indexOf(item)
        if (confirm(`Tem certeza que deseja deletar a tag: ${item.descricao}?`)) {
          this.deleteTag(item._id);
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, new Tag());
          this.editedIndex = -1;
        }, 300);
      },

      save () {
        if (this.editedIndex > -1) {
          this.updateTag(this.editedItem);
        } else {
          this.createTag(this.editedItem);
        }
        this.close()
      },
    },
  }
</script>